/*
 * 注意：本文件是只读的！ 
 * 如需修改 请阅读 → /doc/hyproto/README.md 
 */

import Taf from './libwup';

var HUYA = {};
export default HUYA;

HUYA.EWebSocketCommandType = 
{
    EWSCmd_NULL: 0,
    EWSCmd_RegisterReq: 1,
    EWSCmd_RegisterRsp: 2,
    EWSCmd_WupReq: 3,
    EWSCmd_WupRsp: 4,
    EWSCmdC2S_HeartBeat: 5,
    EWSCmdS2C_HeartBeatAck: 6,
    EWSCmdS2C_MsgPushReq: 7,
    EWSCmdC2S_DeregisterReq: 8,
    EWSCmdS2C_DeRegisterRsp: 9,
    EWSCmdC2S_VerifyCookieReq: 10,
    EWSCmdS2C_VerifyCookieRsp: 11,
    EWSCmdC2S_VerifyHuyaTokenReq: 12,
    EWSCmdS2C_VerifyHuyaTokenRsp: 13,
    EWSCmdC2S_UNVerifyReq: 14,
    EWSCmdS2C_UNVerifyRsp: 15,
    EWSCmdC2S_RegisterGroupReq: 16,
    EWSCmdS2C_RegisterGroupRsp: 17,
    EWSCmdC2S_UnRegisterGroupReq: 18,
    EWSCmdS2C_UnRegisterGroupRsp: 19,
    EWSCmdC2S_HeartBeatReq: 20,
    EWSCmdS2C_HeartBeatRsp: 21,
    EWSCmdS2C_MsgPushReq_V2: 22,
    EWSCmdC2S_UpdateUserExpsReq: 23,
    EWSCmdS2C_UpdateUserExpsRsp: 24,
    EWSCmdC2S_WSHistoryMsgReq: 25,
    EWSCmdS2C_WSHistoryMsgRsp: 26,
    EWSCmdS2C_EnterP2P: 27,
    EWSCmdS2C_EnterP2PAck: 28,
    EWSCmdS2C_ExitP2P: 29,
    EWSCmdS2C_ExitP2PAck: 30,
    EWSCmdC2S_SyncGroupReq: 31,
    EWSCmdS2C_SyncGroupRsp: 32,
    EWSCmdC2S_UpdateUserInfoReq: 33,
    EWSCmdS2C_UpdateUserInfoRsp: 34,
    EWSCmdC2S_MsgAckReq: 35,
    EWSCmdS2C_MsgAckRsp: 36,
    EWSCmdC2S_CloudGameReq: 37,
    EWSCmdS2C_CloudGamePush: 38,
    EWSCmdS2C_CloudGameRsp: 39,
    EWSCmdS2C_RpcReq: 40,
    EWSCmdC2S_RpcRsp: 41,
    EWSCmdS2C_RpcRspRsp: 42,
    EWSCmdC2S_GetStunPortReq: 101,
    EWSCmdS2C_GetStunPortRsp: 102,
    EWSCmdC2S_WebRTCOfferReq: 103,
    EWSCmdS2C_WebRTCOfferRsp: 104,
    EWSCmdC2S_SignalUpgradeReq: 105,
    EWSCmdS2C_SignalUpgradeRsp: 106
};
HUYA.ELiveSource = 
{
    PC_YY: 0,
    PC_HUYA: 1,
    MOBILE_HUYA: 2,
    WEB_HUYA: 3
};
HUYA.EGender = 
{
    MALE: 0,
    FEMALE: 1
};
HUYA.TemplateType = 
{
    PRIMARY: 1,
    RECEPTION: 2
};
HUYA.EStreamLineType = 
{
    STREAM_LINE_OLD_YY: 0,
    STREAM_LINE_WS: 1,
    STREAM_LINE_NEW_YY: 2,
    STREAM_LINE_AL: 3,
    STREAM_LINE_HUYA: 4,
    STREAM_LINE_TX: 5,
    STREAM_LINE_CDN: 8,
    STREAM_LINE_HW: 6,
    STREAM_LINE_BD: 7,
    STREAM_LINE_GG: 9,
    STREAM_LINE_CF: 10,
    STREAM_LINE_QUICK_HUYA: 99
};
HUYA.eUserOperation = 
{
    USER_IN: 1,
    USER_OUT: 2,
    USER_MOVE: 3
};
HUYA.WebSocketCommand = function()
{
    this.iCmdType = 0;
    this.vData = new Taf.BinBuffer();
    this.lRequestId = 0;
    this.traceId = "";
    this.iEncryptType = 0;
    this.lTime = 0;
    this.sMD5 = "";
};
HUYA.WebSocketCommand.prototype._clone = function () { return new HUYA.WebSocketCommand(); }
HUYA.WebSocketCommand.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WebSocketCommand.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WebSocketCommand.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iCmdType);
    os.writeBytes(1, this.vData);
    os.writeInt64(2, this.lRequestId);
    os.writeString(3, this.traceId);
    os.writeInt32(4, this.iEncryptType);
    os.writeInt64(5, this.lTime);
    os.writeString(6, this.sMD5);
};

HUYA.WebSocketCommand.prototype.readFrom = function (is)
{
    this.iCmdType= is.readInt32(0, false, this.iCmdType);
    this.vData= is.readBytes(1, false, this.vData);
    this.lRequestId= is.readInt64(2, false, this.lRequestId);
    this.traceId= is.readString(3, false, this.traceId);
    this.iEncryptType= is.readInt32(4, false, this.iEncryptType);
    this.lTime= is.readInt64(5, false, this.lTime);
    this.sMD5= is.readString(6, false, this.sMD5);
};
HUYA.WSRegisterRsp = function()
{
    this.iResCode = 0;
    this.lRequestId = 0;
    this.sMessage = "";
    this.sBCConnHost = "";
};
HUYA.WSRegisterRsp.prototype._clone = function () { return new HUYA.WSRegisterRsp(); }
HUYA.WSRegisterRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSRegisterRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSRegisterRsp.prototype.readFrom = function (is)
{
    this.iResCode= is.readInt32(0, false, this.iResCode);
    this.lRequestId= is.readInt64(1, false, this.lRequestId);
    this.sMessage= is.readString(2, false, this.sMessage);
    this.sBCConnHost= is.readString(3, false, this.sBCConnHost);
};
HUYA.WSPushMessage = function()
{
    this.ePushType = 0;
    this.iUri = 0;
    this.sMsg = new Taf.BinBuffer();
    this.iProtocolType = 0;
    this.sGroupId = "";
    this.lMsgId = 0;
    this.iMsgTag = 0;
};
HUYA.WSPushMessage.prototype._clone = function () { return new HUYA.WSPushMessage(); }
HUYA.WSPushMessage.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSPushMessage.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSPushMessage.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.ePushType);
    os.writeInt64(1, this.iUri);
    os.writeBytes(2, this.sMsg);
    os.writeInt32(3, this.iProtocolType);
    os.writeString(4, this.sGroupId);
    os.writeInt64(5, this.lMsgId);
    os.writeInt32(6, this.iMsgTag);
};

HUYA.WSPushMessage.prototype.readFrom = function (is)
{
    this.ePushType= is.readInt32(0, false, this.ePushType);
    this.iUri= is.readInt64(1, false, this.iUri);
    this.sMsg= is.readBytes(2, false, this.sMsg);
    this.iProtocolType= is.readInt32(3, false, this.iProtocolType);
    this.sGroupId= is.readString(4, false, this.sGroupId);
    this.lMsgId= is.readInt64(5, false, this.lMsgId);
    this.iMsgTag= is.readInt32(6, false, this.iMsgTag);
};
HUYA.WSUserInfo = function()
{
    this.lUid = 0;
    this.bAnonymous = true;
    this.sGuid = "";
    this.sToken = "";
    this.lTid = 0;
    this.lSid = 0;
    this.lGroupId = 0;
    this.lGroupType = 0;
    this.sAppId = "";
    this.sUA = "";
};
HUYA.WSUserInfo.prototype._clone = function () { return new HUYA.WSUserInfo(); }
HUYA.WSUserInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUserInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSUserInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeBoolean(1, this.bAnonymous);
    os.writeString(2, this.sGuid);
    os.writeString(3, this.sToken);
    os.writeInt64(4, this.lTid);
    os.writeInt64(5, this.lSid);
    os.writeInt64(6, this.lGroupId);
    os.writeInt64(7, this.lGroupType);
    os.writeString(8, this.sAppId);
    os.writeString(9, this.sUA);
};

HUYA.WSUserInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.bAnonymous= is.readBoolean(1, false, this.bAnonymous);
    this.sGuid= is.readString(2, false, this.sGuid);
    this.sToken= is.readString(3, false, this.sToken);
    this.lTid= is.readInt64(4, false, this.lTid);
    this.lSid= is.readInt64(5, false, this.lSid);
    this.lGroupId= is.readInt64(6, false, this.lGroupId);
    this.lGroupType= is.readInt64(7, false, this.lGroupType);
    this.sAppId= is.readString(8, false, this.sAppId);
    this.sUA= is.readString(9, false, this.sUA);
};
HUYA.WSVerifyCookieReq = function()
{
    this.lUid = 0;
    this.sUA = "";
    this.sCookie = "";
    this.sGuid = "";
    this.bAutoRegisterUid = 0;
    this.sAppSrc = "";
};
HUYA.WSVerifyCookieReq.prototype._clone = function () { return new HUYA.WSVerifyCookieReq(); }
HUYA.WSVerifyCookieReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSVerifyCookieReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSVerifyCookieReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sUA);
    os.writeString(2, this.sCookie);
    os.writeString(3, this.sGuid);
    os.writeInt32(4, this.bAutoRegisterUid);
    os.writeString(5, this.sAppSrc);
};


HUYA.WSVerifyCookieRsp = function()
{
    this.iValidate = 0;
};
HUYA.WSVerifyCookieRsp.prototype._clone = function () { return new HUYA.WSVerifyCookieRsp(); }
HUYA.WSVerifyCookieRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSVerifyCookieRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSVerifyCookieRsp.prototype.readFrom = function (is)
{
    this.iValidate= is.readInt32(0, false, this.iValidate);
};
HUYA.WSVerifyHuyaTokenReq = function()
{
    this.tId = new HUYA.UserId();
    this.bAutoRegisterUid = 0;
    this.sAppSrc = "";
};
HUYA.WSVerifyHuyaTokenReq.prototype._clone = function () { return new HUYA.WSVerifyHuyaTokenReq(); }
HUYA.WSVerifyHuyaTokenReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSVerifyHuyaTokenReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSVerifyHuyaTokenReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt32(1, this.bAutoRegisterUid);
    os.writeString(2, this.sAppSrc);
};


HUYA.WSVerifyHuyaTokenRsp = function()
{
    this.iValidate = 0;
};
HUYA.WSVerifyHuyaTokenRsp.prototype._clone = function () { return new HUYA.WSVerifyHuyaTokenRsp(); }
HUYA.WSVerifyHuyaTokenRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSVerifyHuyaTokenRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSVerifyHuyaTokenRsp.prototype.readFrom = function (is)
{
    this.iValidate= is.readInt32(0, false, this.iValidate);
};
HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};
HUYA.WSRegisterGroupReq = function()
{
    this.vGroupId = new Taf.Vector(new Taf.STRING());
    this.sToken = "";
};
HUYA.WSRegisterGroupReq.prototype._clone = function () { return new HUYA.WSRegisterGroupReq(); }
HUYA.WSRegisterGroupReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSRegisterGroupReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSRegisterGroupReq.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vGroupId);
    os.writeString(1, this.sToken);
};


HUYA.WSRegisterGroupRsp = function()
{
    this.iResCode = 0;
    this.vSupportP2PGroupId = new Taf.Vector(new Taf.STRING());
};
HUYA.WSRegisterGroupRsp.prototype._clone = function () { return new HUYA.WSRegisterGroupRsp(); }
HUYA.WSRegisterGroupRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSRegisterGroupRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSRegisterGroupRsp.prototype.readFrom = function (is)
{
    this.iResCode= is.readInt32(0, false, this.iResCode);
    this.vSupportP2PGroupId= is.readVector(1, false, this.vSupportP2PGroupId);
};
HUYA.WSUpdateUserInfoReq = function()
{
    this.sAppSrc = "";
    this.sGuid = "";
    this.iReportMsgIdRatio = 0;
    this.iSupportAck = 0;
    this.tWSMsgStatInfo = new HUYA.WSMsgStatInfo();
};
HUYA.WSUpdateUserInfoReq.prototype._clone = function () { return new HUYA.WSUpdateUserInfoReq(); }
HUYA.WSUpdateUserInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUpdateUserInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSUpdateUserInfoReq.prototype.writeTo = function (os)
{
    os.writeString(0, this.sAppSrc);
    os.writeString(1, this.sGuid);
    os.writeInt32(2, this.iReportMsgIdRatio);
    os.writeInt32(3, this.iSupportAck);
    os.writeStruct(6, this.tWSMsgStatInfo);
};


HUYA.WSUpdateUserInfoRsp = function()
{
    this.iResCode = 0;
    this.iSupportAckMsgStat = 0;
};
HUYA.WSUpdateUserInfoRsp.prototype._clone = function () { return new HUYA.WSUpdateUserInfoRsp(); }
HUYA.WSUpdateUserInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUpdateUserInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSUpdateUserInfoRsp.prototype.readFrom = function (is)
{
    this.iResCode= is.readInt32(0, false, this.iResCode);
    this.iSupportAckMsgStat= is.readInt32(1, false, this.iSupportAckMsgStat);
};
HUYA.WSMsgStatInfo = function()
{
    this.mSignalPushUriCount = new Taf.Map(new Taf.STRING(), new Taf.Map(new Taf.INT64(), new Taf.INT32()));
    this.mP2pPushUriCount = new Taf.Map(new Taf.STRING(), new Taf.Map(new Taf.INT64(), new Taf.INT32()));
    this.iSupportAckMsgStat = 0;
};
HUYA.WSMsgStatInfo.prototype._clone = function () { return new HUYA.WSMsgStatInfo(); }
HUYA.WSMsgStatInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSMsgStatInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSMsgStatInfo.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mSignalPushUriCount);
    os.writeMap(1, this.mP2pPushUriCount);
    os.writeInt32(3, this.iSupportAckMsgStat);
};

HUYA.WSMsgStatInfo.prototype.readFrom = function (is)
{
    this.mSignalPushUriCount= is.readMap(0, false, this.mSignalPushUriCount);
    this.mP2pPushUriCount= is.readMap(1, false, this.mP2pPushUriCount);
    this.iSupportAckMsgStat= is.readInt32(3, false, this.iSupportAckMsgStat);
};
HUYA.WSRedirect = function()
{
    this.vRemoveIps = new Taf.Vector(new Taf.STRING());
    this.sRedirectIp = "";
};
HUYA.WSRedirect.prototype._clone = function () { return new HUYA.WSRedirect(); }
HUYA.WSRedirect.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSRedirect.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSRedirect.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vRemoveIps);
    os.writeString(1, this.sRedirectIp);
};

HUYA.WSRedirect.prototype.readFrom = function (is)
{
    this.vRemoveIps= is.readVector(0, false, this.vRemoveIps);
    this.sRedirectIp= is.readString(1, false, this.sRedirectIp);
};
HUYA.WSPushMessage_V2 = function()
{
    this.sGroupId = "";
    this.vMsgItem = new Taf.Vector(new HUYA.WSMsgItem());
};
HUYA.WSPushMessage_V2.prototype._clone = function () { return new HUYA.WSPushMessage_V2(); }
HUYA.WSPushMessage_V2.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSPushMessage_V2.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSPushMessage_V2.prototype.writeTo = function (os)
{
    os.writeString(0, this.sGroupId);
    os.writeVector(1, this.vMsgItem);
};

HUYA.WSPushMessage_V2.prototype.readFrom = function (is)
{
    this.sGroupId= is.readString(0, false, this.sGroupId);
    this.vMsgItem= is.readVector(1, false, this.vMsgItem);
};
HUYA.WSMsgItem = function()
{
    this.iUri = 0;
    this.sMsg = new Taf.BinBuffer();
    this.lMsgId = 0;
};
HUYA.WSMsgItem.prototype._clone = function () { return new HUYA.WSMsgItem(); }
HUYA.WSMsgItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSMsgItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSMsgItem.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.iUri);
    os.writeBytes(1, this.sMsg);
    os.writeInt64(2, this.lMsgId);
};

HUYA.WSMsgItem.prototype.readFrom = function (is)
{
    this.iUri= is.readInt64(0, false, this.iUri);
    this.sMsg= is.readBytes(1, false, this.sMsg);
    this.lMsgId= is.readInt64(2, false, this.lMsgId);
};
HUYA.LiveLaunchReq = function()
{
    this.tId = new HUYA.UserId();
    this.tLiveUB = new HUYA.LiveUserbase();
    this.bSupportDomain = 0;
};
HUYA.LiveLaunchReq.prototype._clone = function () { return new HUYA.LiveLaunchReq(); }
HUYA.LiveLaunchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveLaunchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveLaunchReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeStruct(1, this.tLiveUB);
    os.writeInt32(2, this.bSupportDomain);
};


HUYA.LiveLaunchRsp = function()
{
    this.sGuid = "";
    this.iTime = 0;
    this.vProxyList = new Taf.Vector(new HUYA.LiveProxyValue());
    this.eAccess = 0;
    this.sClientIp = "";
};
HUYA.LiveLaunchRsp.prototype._clone = function () { return new HUYA.LiveLaunchRsp(); }
HUYA.LiveLaunchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveLaunchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.LiveLaunchRsp.prototype.readFrom = function (is)
{
    this.sGuid= is.readString(0, false, this.sGuid);
    this.iTime= is.readInt32(1, false, this.iTime);
    this.vProxyList= is.readVector(2, false, this.vProxyList);
    this.eAccess= is.readInt32(3, false, this.eAccess);
    this.sClientIp= is.readString(4, false, this.sClientIp);
};
HUYA.LiveProxyValue = function()
{
    this.eProxyType = 0;
    this.sProxy = new Taf.Vector(new Taf.STRING());
};
HUYA.LiveProxyValue.prototype._clone = function () { return new HUYA.LiveProxyValue(); }
HUYA.LiveProxyValue.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.LiveProxyValue.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.LiveProxyValue.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.eProxyType);
    os.writeVector(1, this.sProxy);
};

HUYA.LiveProxyValue.prototype.readFrom = function (is)
{
    this.eProxyType= is.readInt32(0, false, this.eProxyType);
    this.sProxy= is.readVector(1, false, this.sProxy);
};
HUYA.WSLaunchReq = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sUA = "";
    this.sAppSrc = "";
    this.tDeviceInfo = new HUYA.WSDeviceInfo();
};
HUYA.WSLaunchReq.prototype._clone = function () { return new HUYA.WSLaunchReq(); }
HUYA.WSLaunchReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSLaunchReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSLaunchReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sUA);
    os.writeString(3, this.sAppSrc);
    os.writeStruct(4, this.tDeviceInfo);
};


HUYA.WSLaunchRsp = function()
{
    this.sGuid = "";
    this.sClientIp = "";
};
HUYA.WSLaunchRsp.prototype._clone = function () { return new HUYA.WSLaunchRsp(); }
HUYA.WSLaunchRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSLaunchRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSLaunchRsp.prototype.readFrom = function (is)
{
    this.sGuid= is.readString(0, false, this.sGuid);
    this.sClientIp= is.readString(1, false, this.sClientIp);
};
HUYA.WSDeviceInfo = function()
{
    this.sIMEI = "";
    this.sAPN = "";
    this.sNetType = "";
    this.sDeviceId = "";
    this.sMId = "";
};
HUYA.WSDeviceInfo.prototype._clone = function () { return new HUYA.WSDeviceInfo(); }
HUYA.WSDeviceInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSDeviceInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSDeviceInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.sIMEI);
    os.writeString(1, this.sAPN);
    os.writeString(2, this.sNetType);
    os.writeString(3, this.sDeviceId);
    os.writeString(4, this.sMId);
};

HUYA.WSDeviceInfo.prototype.readFrom = function (is)
{
    this.sIMEI= is.readString(0, false, this.sIMEI);
    this.sAPN= is.readString(1, false, this.sAPN);
    this.sNetType= is.readString(2, false, this.sNetType);
    this.sDeviceId= is.readString(3, false, this.sDeviceId);
    this.sMId= is.readString(4, false, this.sMId);
};
HUYA.QueryHttpDnsReq = function()
{
    this.lUid = 0;
    this.sUA = "";
    this.vDomain = new Taf.Vector(new Taf.STRING());
    this.sAppSrc = "";
    this.sClientIp = "";
    this.iIpStack = 0;
    this.iIpType = 0;
};
HUYA.QueryHttpDnsReq.prototype._clone = function () { return new HUYA.QueryHttpDnsReq(); }
HUYA.QueryHttpDnsReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.QueryHttpDnsReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.QueryHttpDnsReq.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sUA);
    os.writeVector(2, this.vDomain);
    os.writeString(3, this.sAppSrc);
    os.writeString(4, this.sClientIp);
    os.writeInt32(5, this.iIpStack);
    os.writeInt32(6, this.iIpType);
};


HUYA.QueryHttpDnsRsp = function()
{
    this.mDomain2Ip = new Taf.Map(new Taf.STRING(), new HUYA.HttpDnsItem());
    this.iEnvType = 0;
};
HUYA.QueryHttpDnsRsp.prototype._clone = function () { return new HUYA.QueryHttpDnsRsp(); }
HUYA.QueryHttpDnsRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.QueryHttpDnsRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.QueryHttpDnsRsp.prototype.readFrom = function (is)
{
    this.mDomain2Ip= is.readMap(0, false, this.mDomain2Ip);
    this.iEnvType= is.readInt32(1, false, this.iEnvType);
};
HUYA.HttpDnsItem = function()
{
    this.vIp = new Taf.Vector(new Taf.STRING());
    this.iExpireTime = 0;
    this.vIpv6 = new Taf.Vector(new Taf.STRING());
};
HUYA.HttpDnsItem.prototype._clone = function () { return new HUYA.HttpDnsItem(); }
HUYA.HttpDnsItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.HttpDnsItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.HttpDnsItem.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vIp);
    os.writeInt64(1, this.iExpireTime);
    os.writeVector(2, this.vIpv6);
};

HUYA.HttpDnsItem.prototype.readFrom = function (is)
{
    this.vIp= is.readVector(0, false, this.vIp);
    this.iExpireTime= is.readInt64(1, false, this.iExpireTime);
    this.vIpv6= is.readVector(2, false, this.vIpv6);
};
HUYA.MetricDetailSet = function()
{
    this.tId = new HUYA.UserId();
    this.vMetricDetail = new Taf.Vector(new HUYA.MetricDetail());
};
HUYA.MetricDetailSet.prototype._clone = function () { return new HUYA.MetricDetailSet(); }
HUYA.MetricDetailSet.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MetricDetailSet.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MetricDetailSet.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeVector(1, this.vMetricDetail);
};

HUYA.MetricDetailSet.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, true, this.tId);
    this.vMetricDetail= is.readVector(1, true, this.vMetricDetail);
};
HUYA.MetricDetail = function()
{
    this.sMetricName = "";
    this.iTS = 0;
    this.vDimension = new Taf.Vector(new HUYA.Dimension());
    this.vFiled = new Taf.Vector(new HUYA.Field());
    this.vExLog = new Taf.Vector(new HUYA.Dimension());
};
HUYA.MetricDetail.prototype._clone = function () { return new HUYA.MetricDetail(); }
HUYA.MetricDetail.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.MetricDetail.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.MetricDetail.prototype.writeTo = function (os)
{
    os.writeString(0, this.sMetricName);
    os.writeInt64(1, this.iTS);
    os.writeVector(2, this.vDimension);
    os.writeVector(3, this.vFiled);
    os.writeVector(4, this.vExLog);
};

HUYA.MetricDetail.prototype.readFrom = function (is)
{
    this.sMetricName= is.readString(0, true, this.sMetricName);
    this.iTS= is.readInt64(1, false, this.iTS);
    this.vDimension= is.readVector(2, false, this.vDimension);
    this.vFiled= is.readVector(3, false, this.vFiled);
    this.vExLog= is.readVector(4, false, this.vExLog);
};
HUYA.Field = function()
{
    this.sName = "";
    this.fValue = 0;
};
HUYA.Field.prototype._clone = function () { return new HUYA.Field(); }
HUYA.Field.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.Field.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.Field.prototype.writeTo = function (os)
{
    os.writeString(0, this.sName);
    os.writeDouble(1, this.fValue);
};

HUYA.Field.prototype.readFrom = function (is)
{
    this.sName= is.readString(0, false, this.sName);
    this.fValue= is.readDouble(1, false, this.fValue);
};
HUYA.Dimension = function()
{
    this.sName = "";
    this.sValue = "";
};
HUYA.Dimension.prototype._clone = function () { return new HUYA.Dimension(); }
HUYA.Dimension.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.Dimension.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.Dimension.prototype.writeTo = function (os)
{
    os.writeString(0, this.sName);
    os.writeString(1, this.sValue);
};

HUYA.Dimension.prototype.readFrom = function (is)
{
    this.sName= is.readString(0, false, this.sName);
    this.sValue= is.readString(1, false, this.sValue);
};
HUYA.WSUnRegisterGroupReq = function()
{
    this.vGroupId = new Taf.Vector(new Taf.STRING());
};
HUYA.WSUnRegisterGroupReq.prototype._clone = function () { return new HUYA.WSUnRegisterGroupReq(); }
HUYA.WSUnRegisterGroupReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUnRegisterGroupReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSUnRegisterGroupReq.prototype.writeTo = function (os)
{
    os.writeVector(0, this.vGroupId);
};


HUYA.WSUnRegisterGroupRsp = function()
{
    this.iResCode = 0;
};
HUYA.WSUnRegisterGroupRsp.prototype._clone = function () { return new HUYA.WSUnRegisterGroupRsp(); }
HUYA.WSUnRegisterGroupRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUnRegisterGroupRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSUnRegisterGroupRsp.prototype.readFrom = function (is)
{
    this.iResCode= is.readInt32(0, false, this.iResCode);
};
HUYA.WSConnectParaInfo = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sUA = "";
    this.sAppSrc = "";
    this.sMid = "";
    this.sExp = "";
    this.iTokenType = 0;
    this.sToken = "";
    this.sCookie = "";
    this.sTraceId = "";
    this.mCustomHeaders = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.WSConnectParaInfo.prototype._clone = function () { return new HUYA.WSConnectParaInfo(); }
HUYA.WSConnectParaInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSConnectParaInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSConnectParaInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sUA);
    os.writeString(3, this.sAppSrc);
    os.writeString(4, this.sMid);
    os.writeString(5, this.sExp);
    os.writeInt32(6, this.iTokenType);
    os.writeString(7, this.sToken);
    os.writeString(8, this.sCookie);
    os.writeString(9, this.sTraceId);
    os.writeMap(10, this.mCustomHeaders);
};

HUYA.WSConnectParaInfo.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sUA= is.readString(2, false, this.sUA);
    this.sAppSrc= is.readString(3, false, this.sAppSrc);
    this.sMid= is.readString(4, false, this.sMid);
    this.sExp= is.readString(5, false, this.sExp);
    this.iTokenType= is.readInt32(6, false, this.iTokenType);
    this.sToken= is.readString(7, false, this.sToken);
    this.sCookie= is.readString(8, false, this.sCookie);
    this.sTraceId= is.readString(9, false, this.sTraceId);
    this.mCustomHeaders= is.readMap(10, false, this.mCustomHeaders);
};
HUYA.CloudGamePacket = function()
{
    this.sToken = "";
    this.sCommand = "";
    this.packetBytes = new Taf.BinBuffer();
    this.sRequestId = "";
};
HUYA.CloudGamePacket.prototype._clone = function () { return new HUYA.CloudGamePacket(); }
HUYA.CloudGamePacket.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.CloudGamePacket.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.CloudGamePacket.prototype.writeTo = function (os)
{
    os.writeString(0, this.sToken);
    os.writeString(1, this.sCommand);
    os.writeBytes(2, this.packetBytes);
    os.writeString(3, this.sRequestId);
};

HUYA.CloudGamePacket.prototype.readFrom = function (is)
{
    this.sToken= is.readString(0, false, this.sToken);
    this.sCommand= is.readString(1, false, this.sCommand);
    this.packetBytes= is.readBytes(2, false, this.packetBytes);
    this.sRequestId= is.readString(3, false, this.sRequestId);
};
HUYA.WSUpdateUserExpsReq = function()
{
    this.mExps = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};
HUYA.WSUpdateUserExpsReq.prototype._clone = function () { return new HUYA.WSUpdateUserExpsReq(); }
HUYA.WSUpdateUserExpsReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUpdateUserExpsReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.WSUpdateUserExpsReq.prototype.writeTo = function (os)
{
    os.writeMap(0, this.mExps);
};


HUYA.WSUpdateUserExpsRsp = function()
{
    this.iResCode = 0;
};
HUYA.WSUpdateUserExpsRsp.prototype._clone = function () { return new HUYA.WSUpdateUserExpsRsp(); }
HUYA.WSUpdateUserExpsRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.WSUpdateUserExpsRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }



HUYA.WSUpdateUserExpsRsp.prototype.readFrom = function (is)
{
    this.iResCode= is.readInt32(0, false, this.iResCode);
};
